import {truchateString} from "../../../../utils/utils";
import {useNavigate} from "react-router-dom";
import {getRoute} from "../../practice/root/PracticeRoot";
import {useState} from "react";
import NotificationCommentModal from "../../../../Modals/notification-comment-modal/notification-comment-modal";

export function NotificationItemAnimation() {

    return (
        <div className={"flex flex-col pt-2 border-b-[1px]  pb-4 last:border-b-0 gap-2"}>
            <div className={"animate-pulse self-end w-1/4 h-2 bg-gray-300 rounded-lg"}></div>
            <div className={"animate-pulse w-full h-3 bg-gray-300 rounded-lg"}></div>
            <div className={"animate-pulse w-full h-3 bg-gray-300 rounded-lg"}></div>
            <div className={"animate-pulse w-1/4 h-3 bg-gray-300 rounded-lg"}></div>
        </div>
    )
}

export default function NotificationItem({
                                             className,
                                             comment,
                                             message,
                                             created_at,
                                             user,
                                             notification_type,
                                             question,
                                             ...props
                                         }) {
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false)

    return (
        <div onClick={() => setIsModalOpen(true)}
             className={` ${className} hover:bg-gray-50 cursor-pointer pt-2 flex flex-col gap-3 border-b-[1px] last:border-b-0 pb-4`}>
            <NotificationCommentModal
                isOpen={isModalOpen}
                setOpen={setIsModalOpen}
                comment={comment}
            />
            <p className={"text-end text-xs text-gray-400"}>
                {created_at?.split("-")?.[0] || "-"}
            </p>
            <p className={"text-sm"}>
                <span
                    className={"font-semibold text-tertiary-900"}>{message}</span>"{truchateString(comment?.text, 200)}"
            </p>
            {
                question && <div className={"flex flex-row justify-end"}>
                    <p
                        onClick={() => {
                            navigate(getRoute(question?.name, question?.id))
                        }}
                        className={"border-[1px] border-secondary-900 text-secondary-900 rounded-md px-2 text-end text-xs "}>
                        #{question?.id}
                    </p>
                </div>
            }

        </div>

    )
}